import { Component } from 'react';
import { EnvService, FilterItem, FilterItemOperator, SortItem } from 'namirasoft-core';
import { IBaseComponentProps, NSButtonBlue, NSDialog, NSDialogProps, NSLoading, NSNoData, StringFormatter } from "namirasoft-site-react";
import { NamirasoftMessageMetaDatabase, MessageRow, NamirasoftMessageServer } from 'namirasoft-message';
import { NSARouterMakerProps } from '../NSARouterMakerProps';
import Styles from './NSAMessageListDialog.module.css';

export interface NSAMessageListDialogProps extends NSARouterMakerProps, NSDialogProps, IBaseComponentProps
{
	onClose: () => void;
	onSeenAll: () => void;
	onMessageClick: () => void;
}

export interface NSAMessageListDialogState
{
	messages: MessageRow[] | null;
}

export class NSAMessageListDialog extends Component<NSAMessageListDialogProps, NSAMessageListDialogState>
{
	constructor(props: NSAMessageListDialogProps)
	{
		super(props);
		this.state = { messages: null };
		this.onMarkAll = this.onMarkAll.bind(this);
	}
	override componentDidMount(): void
	{
		let meta = new NamirasoftMessageMetaDatabase(this.props.account.token_manager, this.props.notifier.onError);
		let REACT_APP_BASE_URL_MESSAGE = new EnvService("REACT_APP_BASE_URL_MESSAGE", true).getString();
		let server = new NamirasoftMessageServer(REACT_APP_BASE_URL_MESSAGE, this.props.account.token_manager, this.props.notifier.onError);
		let filters = [new FilterItem(meta.tables.message, meta.tables.message.columns.seen_at, false, FilterItemOperator.all.empty)];
		let sorts = [new SortItem(meta.tables.message, meta.tables.message.columns.created_at, false)];
		server.message.List(filters, 1, 4, sorts).then(res =>
		{
			this.setState({ messages: res.rows });
		}).catch(() => { });
	}
	onMarkAll(): void
	{
		let REACT_APP_BASE_URL_MESSAGE = new EnvService("REACT_APP_BASE_URL_MESSAGE", true).getString();
		let server = new NamirasoftMessageServer(REACT_APP_BASE_URL_MESSAGE, this.props.account.token_manager, this.props.notifier.onError);
		server.message.SeenAll().then(() =>
		{
			this.props.onSeenAll();
			this.props.onClose();
		}).catch(() => { });
	}
	override render()
	{
		let REACT_APP_BASE_URL_MESSAGE_CONSOLE = new EnvService("REACT_APP_BASE_URL_MESSAGE_CONSOLE").getString();
		let content = null;
		if (this.state.messages === null)
		{
			content = <NSLoading />;
		}
		else if (this.state.messages.length === 0)
		{
			content = <NSNoData lable='No new message' />
		}
		else
		{
			let content_messages = this.state.messages.map(message =>
				<div
					key={message.id}
					className={Styles.nsa_message_item}
					onClick={() =>
					{
						this.props.onMessageClick();
						window.open(REACT_APP_BASE_URL_MESSAGE_CONSOLE + "/message/" + message.id + "/view", "_blank");
						this.props.onClose();
					}}
				>
					<ul className={Styles.nsa_message_item_ul}>
						<li className={`${Styles.nsa_message_item_title}`}>{message.title}</li>
					</ul>
					<p className={`${Styles.nsa_message_item_content} nsa_font_13_normal`}>{
						StringFormatter.toHTML(message.body)
					}</p>
					<span style={{ fontSize: "10px" }}>{new Date(message.created_at).toLocaleString()}</span>
				</div>
			);
			content = (
				<>
					<div className={Styles.nsa_toast}>
						<div className={Styles.nsa_toast_header}>
							<figure className='d-flex flex-row justify-content-center align-item-center mb-0'
								style={{ cursor: "pointer" }}>
								<img
									src="https://static.namirasoft.com/image/concept/mark-all/blue.svg"
									alt="Message Header"
									width={22}
									onClick={this.onMarkAll}
								/>
								<figcaption
									className={`${Styles.nsa_message_title} ms-2`}
									onClick={this.onMarkAll}
								>
									Mark All As Seen
								</figcaption>
							</figure>
						</div>
						<div className={Styles.nsa_toast_body}>
							{content_messages}
						</div>
						<div className='pt-3 mx-0 d-flex justify-content-center'>
							<NSButtonBlue
								onClick={{
									action: () =>
									{
										window.open(REACT_APP_BASE_URL_MESSAGE_CONSOLE + "/message/list", "_blank");
									},
									showLoading: false
								}}
								title='View All'
							/>
						</div>
					</div>
					<div className={Styles.nsa_toast_background}>
					</div>
				</>
			);
		}
		return (
			<NSDialog {...this.props}
				id={this.props.id}
				classList={this.props.classList}
				style={this.props.style}
			>
				{content}
			</NSDialog >
		);
	}
}